module.exports = __webpack_public_path__ + "img/playstore.044282ba.png";